import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';

import { AuthShell } from '../../components/admin/AuthShell';
import { Button, Input, useToast } from '../../components/ui';
import { api, errorMessage } from '../../lib/api';

export function AdminSignupPage() {
  const toast = useToast();
  const [form, setForm] = useState({
    clubName: '',
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  });
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  async function onSubmit(e: FormEvent): Promise<void> {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post('/admin/auth/signup', form);
      setDone(true);
    } catch (err) {
      toast.push(errorMessage(err), 'error');
    } finally {
      setLoading(false);
    }
  }

  if (done) {
    return (
      <AuthShell title="Check your email" subtitle="We sent a verification link to your inbox.">
        <Link to="/admin/login" className="text-navy-900 underline">
          Back to sign in
        </Link>
      </AuthShell>
    );
  }

  return (
    <AuthShell
      title="Start a club"
      subtitle="Free during beta."
      footer={
        <>
          Already have an account?{' '}
          <Link to="/admin/login" className="text-navy-900 underline">
            Sign in
          </Link>
        </>
      }
    >
      <form onSubmit={onSubmit} className="space-y-4">
        <Input label="Club name" value={form.clubName} onChange={(e) => setForm({ ...form, clubName: e.target.value })} required />
        <div className="grid grid-cols-2 gap-3">
          <Input label="First name" value={form.firstName} onChange={(e) => setForm({ ...form, firstName: e.target.value })} required />
          <Input label="Last name" value={form.lastName} onChange={(e) => setForm({ ...form, lastName: e.target.value })} required />
        </div>
        <Input type="email" label="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required />
        <Input type="password" label="Password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} required />
        <Button type="submit" disabled={loading} className="w-full">
          {loading ? 'Creating…' : 'Create club'}
        </Button>
      </form>
    </AuthShell>
  );
}
